import { useAuth0 } from "@auth0/auth0-react";
import { initializeApp } from "firebase/app";
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from "firebase/remote-config";
import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { axios } from "../../../api/axios";
import {
  shop_brand,
  tranont_brand
} from "../../../assets/icons";
import { authorizeLogin } from "../../../auth0provider";
import PoweredBy from "../../../components/PoweredBy";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppNavigation from "../../../hooks/useAppNavigation";
import { setPassLogin } from "../../agora-live/components/streamControls/controls.actions";
import { setClient, setLanguage, setUserData } from "./login.actions";

const firebaseConfig = {
  apiKey: "AIzaSyBl6Bks9lgSysvu7vbyi1cEapjagZavhdc",
  authDomain: "verblive-1fb34.firebaseapp.com",
  databaseURL: "https://verblive-1fb34.firebaseio.com",
  projectId: "verblive-1fb34",
  storageBucket: "verblive-1fb34.appspot.com",
  messagingSenderId: "899812086138",
  appId: "1:899812086138:web:715082a5819b1a0c1606c3",
  measurementId: "G-2PB480BRR7",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyC8C7wUGCVSnCsmAwrheAB2Tp4a2sDK0PI",
//   authDomain: "verb-live-mobile.firebaseapp.com",
//   databaseURL: "https://verb-live-mobile.firebaseio.com",
//   projectId: "verb-live-mobile",
//   storageBucket: "verb-live-mobile.appspot.com",
//   messagingSenderId: "928540542909",
//   appId: "1:928540542909:web:543abd2f3c44b1db3f34d4",
//   measurementId: "G-EP4GKG18PG"
// };

export default function Login() {
  const dispatch = useAppDispatch();
  const { loginWithRedirect, isAuthenticated, loginWithPopup } = useAuth0();
  const appFirebase: any = initializeApp(firebaseConfig);
  const { navigate } = useAppNavigation();
  const brand = useRef("");

  const passLogin = () => {
    navigate({ screen: "stream" });
    dispatch(setPassLogin());
  };

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const fetchConfig = async () => {
    try {
      const remoteConfig = getRemoteConfig(appFirebase);

      // // Set default values (these should match your Firebase Remote Config defaults)
      // remoteConfig.defaultConfig = {
      //   welcome_message: 'Welcome to our app!',
      //   // Add more default values here
      // };

      // // Fetch remote config values
      // await remoteConfig.fetchAndActivate();

      // // Get all keys and values from Remote Config
      // const remoteConfigValues = remoteConfig.getAll();

      // // Extract the values and create an object
      // const valuesObject: { [key: string]: string } = {};
      // remoteConfigValues.forEach((entry:any) => {
      //   valuesObject[entry.key] = entry.asString();
      // });

      //// console.log("values===>Remote",valuesObject)

      await fetchAndActivate(remoteConfig)
        .then((data) => {
         // console.log("fetch___Val", data);
          // ...
        })
        .catch((err) => {
         // console.log("fetch___Val__ERR", err);
          // ...
        });

      const val = getValue(remoteConfig, "testLiveKey");

     // console.log("vallllllll==>", val);
    } catch (error) {
      console.error("Error fetching remote config:", error);
    }
  };

  const IconContainer = ({
    bg = "bg-white",
    icon,
    type,
  }: {
    bg?: string;
    icon: any;
    type?: any;
  }) => {
    return (
      <div
        className={`${bg} rounded-full p-3 cursor-pointer`}
        onClick={() => {
          authorizeLogin(type, passLogin);
        }}
      >
        <img
          src={icon}
          alt="Icon"
          height={22}
          width={22}
          className="cursor-pointer"
        />
      </div>
    );
  };

  const getUserInfo = async () => {
   // console.log("called API===>", "GET user INFO");
    await axios
      .get("/stream/authenticate")
      .then((response: any) => {
        if (response.publicUserData != null) {
          checkClient(response?.publicUserData?.company_name);

          if (response.publicUserData!.clientId.indexOf("oauth") > -1) {
            response!.publicUserData!.isCRMUser = false;
          } else {
            response!.publicUserData!.isCRMUser = true;
          }

          if (response.publicUserData!.clientId.indexOf("repsites") > -1) {
            response!.publicUserData!.isMAUser = true;
          } else {
            response!.publicUserData!.isMAUser = false;
          }

          if (response.publicUserData!.company_name.indexOf("Ambit Energy") > -1 ||
          response.publicUserData!.company_name.indexOf("Arieyl") > -1 ||
          response.publicUserData!.company_name.indexOf("ovvi") > -1 ||
          response.publicUserData!.company_name.indexOf("eexcelusa") > -1 || 
          response.publicUserData!.company_name.indexOf("E-Excel") > -1
        ) {
            response!.publicUserData!.isMAUser = false;
          }

          if(response.publicUserData!.company_name === "tranont")
          {
            brand.current = tranont_brand;
          } else {
            brand.current = shop_brand;
          }
         // console.log(response!.publicUserData.community_content_creator+'community_content_creator');

          fetch(`${window.location.origin}/lang/${response.publicUserData.display_language ?? "en"}.json`)
            .then((response) => response.json())
            .then((data) => {
              dispatch(setLanguage(data));
            })
            .catch((error) => {
              dispatch(setLanguage({
                "mic_active": "Your microphone is active.",
                "mic_inactive": "Your microphone is muted.",
                "camera_active": "Your camera is active.",
                "camera_inactive": "Your camera is turned off.",
                "mic_camera_inactive": "Your camera is turned off. Your microphone is muted.",
                "go_live": "Go Live",
                "Interactions": "Interactions",
                "Chat": "Chat",
                "Edit": "Edit",
                "feature": "Feature",
                "featured": "Featured",
                "attendees": "Attendees",
                "activities": "Activities",
                "what_on_your_mind": "What's on your mind?",
                "start_live_to_record": "You must start a LIVE stream to record",
                "logout": "Logout",
                "cancel": "Cancel",
                "data_processing_agreement": "Data Processing Agreement",
                "privacy_policy": "Privacy Policy",
                "starting_stream": "Starting Stream",
                "record_on": "Recording is ON",
                "record_off": "Recording is OFF",
                "add_interactions": "Add Interactions",
                "sell": "Sell",
                "media": "Media",
                "link": "Link",
                "select_products": "Select the products you'd like to add",
                "search": "Search",
                "filter_by": "Filter by",
                "publish": "Publish",
                "tap_media": "Tap on the media you'd like to add",
                "add_link": "Add Link",
                "add_links": "You can add links to your live, from websites to social media and instant messengers",
                "link_type": "Link Type",
                "social_media": "Social Media",
                "messengers": "Messengers",
                "custom": "Custom",
                "enter_xxxx_link": "Enter XXXXX link",
                "title": "Title",
                "enter_title": "enter title",
                "display_title": "Display Title",
                "preview": "Preview",
                "add": "Add",
                "upload_image": "Upload custom image",
                "upload_image_successfully": "Upload Successfully!",
                "join_the_livestream": "Join the LIVEstream",
                "join": "Join",
                "sign_up_for_free": "Sign Up for Free",
                "sign_in": "Sign In",
                "verb_crm_user": "Verb CRM user",
                "need_help": "Need help",
                "sign_in_agreement_short": "By signing in, you agree to the data processing agreement and privacy policy",
                "joining_stream": "Joining Stream",
                "my_media": "My media",
                "Save": "Save",
                "Leave": "Leave",
                "leave_video": "Leave Video",
                "ending_stream": "Ending stream",
                "host_mic_video": "Host has turned off his video and muted his Mic",
                "host_mic": "Host has muted his Mic",
                "host_video": "Host has turned off his video",
                "YES": "YES",
                "NO": "NO",
                "EXIT": "Exit the livestream?",
                "you_logged_out": "You logged out",
                "more_options": "More options",
                "last_signed": "Last Signed in through",
                "by_signing": "By signing in, you agree to the",
                "auth_succeess": "Authentication succesful",
                "no_permission_record": "You don't have permission to record",
                "new_chats": "New Chats",
                "has_joined": "has joined",
                "clicked_on": "clicked on",
                "representing_by": "Representing by",
                "referred_by": "Referred by ",
                "please_register": "please register",
                "to_attend": "To attend the LIVE stream",
                "enter_first_name": "Enter First Name",
                "enter_last_name": "Enter Last Name",
                "enter_email": "Enter Email",
                "hosted_by": "The LIVE stream hosted by",
                "starting_soon": " will be starting soon.",
                "and": "and",
                "or": "or",
                "terms_of_use": "terms of use",
                "has_left": "has left",
                "host_ended_live": "The host ended the live.",
                "data_privacy_agreement": "data privacy agreement",
                "to_livestream": "To Livestream",
                "need_access": "We need access to your camera and microphone.",
                "open_settings": "Open Settings",
                "sign_up": "Sign Up",
                "internet_unstable": "Your Internet is Unstable",
                "got_it": "Got It",
                "settings": "Settings",
                "plan": "Plan",
                "max_attendees": "Max Attendees",
                "max_number": "Max Number of minutes",
                "stream_settings": "Stream Settings",
                "hide_attendee_list": "Hide attendee list and number from stream attendees",
                "ability_to_record": "Ability To Record Stream",
                "ability_to_copresenter": "Ability to have a co-presenter",
                "sign_out": "Sign Out",
                "questions_or_need_help": "Questions or Need help",
                "add_your_first_interaction": "Add your first interaction",
                "host_internet_unstable": "Host's Internet is Unstable",
                "invalid_url": "The URL you entered is not valid.",
                "link_invalid": "The link is invalid or expired.",
                "contact_for_new_url": "Please contact the person who sent you this link to get a new one.",
                "welcome_back": "Welcome back! Let's go live again.",
                "to_go_live": "To go live, create a free account.",
                "record_is_starting": "Recording is starting...",
                "record_has_started": "Recording has started.",
                "record_is_ending": "Recording is ending...",
                "record_has_ended": "Recording has ended.",
                "enter_ID": "Enter the meeting I.D, number",
                "clicking_join": "Clicking join indicates that you have read and agree to the ",
                "plan_features": "Plan features",
                "attendees_per_live_stream": "Attendees per Live Stream",
                "minutes_per_live_stream": "Minutes per Live Stream",
                "co_presenter_per_live_stream": "Co-presenter per Live Stream",
                "EULA_title": "Updated Terms of Use, Privacy Policy, and Data Processing Agreement",
                "EULA_body": "Before you can proceed, you must read and agree to the Terms of Use, Privacy Policy, and Data Processing Agreement.",
                "agree": "Agree",
                "view": "View",
                "report_this_post": "Report this post",
                "why_report": "Why should this content be flagged",
                "send": "Send",
                "end_session": "Your Livestream is in session.",
                "confirm_sign_out": "Are you sure you want to sign out?",
                "first_name": "First Name",
                "last_name": "Last Name",
                "email": "Email",
                "agree_join": "By joining you agree to our ",
                "enter_password": "Enter Password",
                "done": "Done",
                "select_site": "Select Site",
                "guide_select_site": "You can only add products from one site to your live. To add products from another site, your live will need to be restarted.",
                "brand": "brand",
                "category": "Category",
                "sub_category": "Sub Category",
                "introduce_golive": "Go live anywhere, anytime",
                "introduce_boost": "Boost engagement with clickable interactions",
                "introduce_record": "Record the livestreams to create sales videos",
                "introduce_invite": "Invite attendees with simple shareable links",
                "join_as_copresenter": "You are joining this LIVEstream as a co-presenter.",
                "waiting_room_join_as_copresenter": "You will join as a co-presenter as soon as the host goes live.",
                "max_presenters": "Max Presenters",
                "next": "Next",
                "skip": "Skip",
                "user_info": "User Info",
                "display_info_updated": "Display information has been updated",
                "edit_info": "Edit Info",
                "delete": "delete",
                "copresenter": "Co-presenter",
                "copresenter_join": "has joined the meeting as a co-presenter and has audio and video capabillity",
                "confirm_leave": "Are you sure you want to leave this stream?",
                "Attendee": "Attendee",
                "Invite": "Invite",
                "you_joined_copresenter": "You have joined the meeting as a co-presenter and have audio and video capability.",
                "confirm_leave_host": "Are you sure you want to end this stream?",
                "start_your_live_stream": "Start your Live stream",
                "share_your_live_stream": "Share your Live stream",
                "list_view_live_interaction": "List view Live interactions",
                "record_stream": "Record Stream",
                "chat_with_attendees": "Chat with Attendees",
                "poor_internet": "Poor internet connection. ",
                "have_av_issues": "The livestream may have audio or video issues.",
                "no_msg": "There are no chat messages yet",
                "go_live_to_start_chatting": "Go live to start chatting",
                "feature_label": "Featured",
                "up_to": "Up",
                "to_limit": "to",
                "minutes_value": "minutes",
                "select_microphone": "Select Microphone",
                "microphone_prompt": "Please select a microphone",
                "input_level": "Input Level",
                "use_portrait": "Use Portrait",
                "select_camera": "Select Camera",
                "camera_prompt": "Please select a camera",
                "preview_label": "Preview:",
                "select_products_prompt": "Select the products that you want to add.",
                "select_brand": "Select Brand",
                "select_categories": "Select Categories",
                "select_sub_categories": "Select Sub Categories",
                "search_label": "Search",
                "creating_stream": "Creating stream please wait...",
                "whats_on_mind": "What's on your mind?",
                "select_media_assets": "Select the media assets you'd like to import from verbCRM.",
                "add_button": "Add",
                "all_button": "All",
                "share_button": "Share",
                "copy_button": "Copy",
                "link_copied": "Link copied to clipboard.",
                "microphone_muted": "Your microphone is muted",
                "microphone_active": "Your microphone is active",
                "camera_off": "Your camera is turned OFF",
                "camera_on": "Your camera is turned ON",
                "joining_stream_wait": "Joining stream please wait",
                "no_interactions": "Interactions have not been added yet",
                "shop_label": "Shop",
                "cart_label": "Cart",
                "no_items": "No items have been added",
                "ending_stream_wait": "Ending stream please wait",
                "left_livestream": "You left the live stream",
                "rejoin_button": "Rejoin",
                "please_wait": "Please wait…",
                "register_view": "Register to view LIVEstream",
                "first_name_field": "First Name",
                "last_name_field": "Last Name",
                "email_field": "Email",
                "join_button": "Join",
                "join_agreement": "Clicking join indicates you have read and agree to the",
                "livestream_hosted": "The LIVEstream hosted by",
                "starting_soon_text": "will be starting soon.",
                "representing_label": "Representing",
                "referred_by_label": "Referred by",
                "host_mic_muted": "Host microphone is muted",
                "already_in_interactions": "is already present in your interactions list",
                "item_label": "Item",
                "exit_livestream": "Exit the live stream?",
                "yes_button": "YES",
                "no_button": "NO",
                "add_to_cart": "Add to cart",
                "update_cart": "Update cart",
                "cashback_label": "Cashback",
                "see_details": "See Details",
                "added_to_cart": "Added to Cart",
                "no_results": "No Results Found",
                "cannt_find": "We can't seem to find any products that match your search.",
                "screen_share": "Screen Share is OFF"
            }));
              console.error(error);
            });
        }
        dispatch(setUserData(response));
        navigate({ screen: "stream" });
      })
      .catch((err: any) => {
        const errorMessage = err?.response?.data?.message || err?.message || "Authentication failed. Please try again.";
        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error("Authentication error:", err);
      });
  };

  const checkClient = (client: any) => {
    return dispatch(setClient(client));
  };

  useEffect(() => {
    fetchConfig();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("token");
   // console.log(token);
    if (token != null) {
      localStorage.setItem("jwt_token", token ?? "");
      getUserInfo();
    } else if (localStorage.getItem("jwt_token") != null) {
      getUserInfo();
    }
  }, []);

  return (
    <div
      className={`flex flex-col w-full`}
      style={{backgroundColor: '#1593D6'}}
    >
      <div className="flex flex-col flex-1 my-12 mx-6 md:mx-72">
        <div
          className="flex flex-1 flex-col rounded-lg bg-gradient-to-r items-center justify-center"
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          {brand.current !== "" && (
            <img
              src={brand.current}
              alt="Icon"
              height={isMobile ? 145 : 290}
              width={isMobile ? 145 : 290}
            style={{ 
              marginTop: 30,
              backgroundColor: 'white',
              padding: isMobile ? 10 : 20,
              borderRadius: 10,
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          )}
          {/* <LogoTitle /> */}

          {/* <span className="text-white text-xs my-2 w-80 text-center mt-6">
            By signing in. you agree to our data
            <a
              href={linksConstants.data_url}
              className="my-2 text-blue-400 ml-1"
            >
              Data Processing Agreement
            </a>
            ,
            <a
              href={linksConstants.privacy_url}
              className="my-2 text-blue-400 ml-1"
            >
              privacy policy
            </a>{" "}
            and
            <a
              href={linksConstants.terms_url}
              className="my-2 text-blue-400 ml-1"
            >
              terms of use.
            </a>
          </span> */}
        </div>
        <div className="mt-4">
          <PoweredBy />
        </div>
      </div>
    </div>
    
  );
}
